import PropTypes from 'prop-types'

import TermItem from './TermItem'

const TermList = ({ terms = [], currentTerm }) => {
  const listTerms = () => {
    return terms.map(
      (term, index) =>
        <TermItem key={ index } { ...term } currentTerm={currentTerm} />
    )
  }

  return (
    <div className="term-list">
      <div className="row no-margin">
        <div className="heading-4 padding-x-small no-margin">
          { terms.length > 1 ? 'Termos' : 'Termo' } da busca
        </div>
      </div>

      <div className="search-terms-header padding-y-small">
        <ul className="search-terms-wrapper color-primary no-padding-x">
          { listTerms() }
        </ul>
      </div>
    </div>
  )
}

TermList.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.shape({
    term: PropTypes.string,
    url: PropTypes.string
  }))
}

export default TermList
